import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth';
import FloatingLeaves from './common/FloatingLeaves';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await authService.login({ email, password });
      
      if (response.success) {
        // Redirect based on user type
        const userType = authService.getUserType();
        if (userType === 'partner') {
          navigate('/partner/dashboard');
        } else {
          navigate('/dashboard');
        }
      } else {
        setError(response.message || 'Login gagal');
      }
    } catch (error: any) {
      console.error('Login failed:', error);
      setError(error.response?.data?.message || 'Terjadi kesalahan saat login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-mangrove-50 via-ocean-50 to-mangrove-100 relative overflow-hidden transition-colors dark:bg-gradient-to-br dark:from-[#1f5850] dark:via-[#1a4d46] dark:to-[#15423c]">
      {/* Floating Leaves Background Effect */}
      <FloatingLeaves />
      
      {/* Decorative blur circles for glassmorphism effect */}
      <div className="absolute top-20 left-20 w-72 h-72 bg-mangrove-300/30 dark:bg-[#2a6b62]/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-ocean-300/30 dark:bg-[#1f5850]/40 rounded-full blur-3xl"></div>
      
      <div className="max-w-md w-full space-y-8 p-10 backdrop-blur-2xl rounded-2xl shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] border border-white/20 relative z-10 transition-all" style={{ backgroundColor: 'rgba(9, 65, 61, 0.9)' }}>

        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-white dark:text-white drop-shadow-sm">Dashboard</h1>

          {/* SeaSoldier Logo */}
          <div className="flex justify-center mb-4">
            <img 
              src="/seasoldier-logo.png" 
              alt="SeaSoldier Logo" 
              className="h-12 w-auto object-contain drop-shadow-lg"
            />
          </div>
          
          <p className="text-gray-100 dark:text-gray-200 font-medium">Platform Monitoring Partner Seasoldier</p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="bg-red-50/90 dark:bg-red-900/40 backdrop-blur-sm border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 px-4 py-3 rounded-md">
              {error}
            </div>
          )}
          
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-white dark:text-gray-100 mb-2">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full px-4 py-3 border border-white/30 dark:border-gray-600/60 rounded-lg shadow-sm bg-white/90 dark:bg-gray-700/60 backdrop-blur-md text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-mangrove-300 focus:border-transparent focus:bg-white transition-all"
              placeholder="Alamat email Anda"
            />
          </div>
          
          <div>
            <label htmlFor="password" className="block text-sm font-semibold text-white dark:text-gray-100 mb-2">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full px-4 py-3 border border-white/30 dark:border-gray-600/60 rounded-lg shadow-sm bg-white/90 dark:bg-gray-700/60 backdrop-blur-md text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-mangrove-300 focus:border-transparent focus:bg-white transition-all"
              placeholder="Password Anda"
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-lg text-base font-semibold text-white bg-gradient-to-r from-mangrove-500 to-mangrove-600 hover:from-mangrove-400 hover:to-mangrove-500 dark:from-mangrove-600 dark:to-mangrove-700 dark:hover:from-mangrove-500 dark:hover:to-mangrove-600 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-mangrove-800/50 dark:focus:ring-offset-gray-900/50 focus:ring-mangrove-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
          >
            {loading ? 'Masuk...' : 'Masuk'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;